import React from "react";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { Upload } from "react-feather";

const ImportStep1FileUpload = ({ addFile }) => {

  const onDrop = (acceptedFiles, data) => {
    const validFiles = acceptedFiles.filter((file) => {
      const fileExtension = file.name.toLowerCase().split(".").pop();
      return ["csv", "xls", "xlsx"].includes(fileExtension);
    });

    if (validFiles.length > 0) {
      addFile(validFiles[0]);
    } else {
      const errorCode = data[0]?.errors[0]?.code;
      const errorMessage = data[0]?.errors[0]?.message;

      if (errorCode === "file-too-large") {
        toast.warning(errorMessage, { autoClose: 3000 });
      } else {
        toast.warning("File type not supported", { autoClose: 3000 });
      }
    }
  };

  return (
    <Dropzone accept={[".csv", ".xls", ".xlsx"]} onDrop={onDrop}>
      {({ getRootProps, getInputProps }) => (
        <div
          {...getRootProps()}
          style={{
            width: "100%",
            border: "2px dashed #CDCDCD",
            height: "275px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
            backgroundColor: "#FDFDFD",
            marginTop: "1rem",
            marginBottom: "1rem"
          }}
        >
          <input {...getInputProps()} />
          <div
            className="d-flex flex-column align-items-center border px-4 py-3 rounded"
            style={{ borderColor: "#d1d1d1", borderWidth: 1, borderStyle: "solid" }}
          >
            <Upload size={50} />
            <div className="fw-semibold">Upload a file</div>
            <div>Select a .csv, xlsx file from your computer</div>
          </div>
        </div>
      )}
    </Dropzone>
  );
};

export default ImportStep1FileUpload;
